// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import { initializeI18n} from '@/i18n'
import UrlUtils from '@/utils/UrlUtils'
import VueSweetAlert from 'vue-sweetalert'
import VueGtm from 'vue-gtm'
import Meta from 'vue-meta'
import GoogleAuth from 'vue-google-auth'
import VueSanitize from "vue-sanitize";

Vue.use(GoogleAuth, { 
  client_id: process.env.GOOGLE_CLIENT_ID
})
Vue.googleAuth().load()
Vue.use(VueSweetAlert)
Vue.use(VueI18n)
Vue.use(Meta)
Vue.use(VueSanitize)


Vue.use(VueGtm, {
  id: 'GTM-5Z4HTG', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['accountremoved'] // If router, you can exclude some routes name (case insensitive) (optional)
})


Vue.config.productionTip = true

let lang = (UrlUtils.getLangaugeName()) ? UrlUtils.getLangaugeName() : ''


store.dispatch('initializeUser')
  .then(function () {
    store.state.languageName = lang
    if (store.state.user.languageName) {
      store.state.languageName = store.state.user.languageName
    }

    let i18n = initializeI18n(store.state.languageName)
    initializeApp(i18n)
  })
  .catch(function () {
    store.state.languageName = lang

    let i18n = initializeI18n(store.state.languageName)
    initializeApp(i18n)
  })

function initializeApp (i18n) {
  return new Vue({
    el: '#app',
    store,
    router,
    i18n,
    template: '<App/>',
    components: { App }
  })
}



// WEBPACK FOOTER //
// ./src/main.js